export const BLOG_POSTS = [
  {
    id: 1,
    slug: 'how-to-book-name-change-ad-in-newspaper',
    title: 'Step-by-Step Guide: How to Book a Name Change Ad in Newspaper',
    excerpt: 'Complete guide on the name change process in India, from creating an affidavit to publishing newspaper ads and updating your official documents.',
    date: 'January 2, 2026',
    author: 'BookMyNewsAd Team',
    image: 'https://images.unsplash.com/photo-1585829365295-ab7cd400c167?q=80&w=1000&auto=format&fit=crop',
    content: [
      {
        type: 'paragraph',
        text: 'To publish a name change ad, first get a notarized affidavit stating your old name, new name, and reason; then, book an ad in local and national newspapers with your details and affidavit info; and finally, submit these documents (affidavit, ad tear sheets) to update IDs like Passport, Aadhaar, and PAN. The process involves creating an affidavit, selecting newspapers (often one national/one local), drafting the text, booking online or offline, making payment, and preserving the newspaper copies.'
      },
      {
        type: 'heading',
        text: 'Step-by-Step Process'
      },
      {
        type: 'subheading',
        text: '1. Prepare the Affidavit'
      },
      {
        type: 'paragraph',
        text: "Draft a sworn statement (affidavit) on non-judicial stamp paper with a notary/lawyer. Include: Your old name, new name, father's/husband's name, address, reason for change, and affidavit number/date."
      },
      {
        type: 'image',
        url: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=1000&auto=format&fit=crop',
        alt: 'Legal Affidavit Document'
      },
      {
        type: 'subheading',
        text: '2. Choose Newspapers'
      },
      {
        type: 'paragraph',
        text: 'Select newspapers (often one national like Times of India and one local) for publication. Booking can be done online through ad booking sites or directly with newspapers.'
      },
      {
        type: 'subheading',
        text: '3. Draft the Advertisement'
      },
      {
        type: 'paragraph',
        text: 'Use a standard format: "I, [Old Name], S/o [Father\'s Name], residing at [Address], have changed my name to [New Name] as per Affidavit No. [Number] dated [Date]". Include your address and contact details.'
      },
      {
        type: 'image',
        url: 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?q=80&w=1000&auto=format&fit=crop',
        alt: 'Drafting Newspaper Ad'
      },
      {
        type: 'subheading',
        text: '4. Book & Pay for the Ad'
      },
      {
        type: 'paragraph',
        text: "Submit your ad text and the notarized affidavit (or its details) to the newspaper's classified section. Pay the required fee, which varies by newspaper and format (text/boxed)."
      },
      {
        type: 'subheading',
        text: '5. Publish & Collect'
      },
      {
        type: 'paragraph',
        text: 'Select your publication date (often next day for urgent cases). Keep the original newspaper copies (tear sheets) as proof.'
      },
      {
        type: 'subheading',
        text: '6. Update Your IDs'
      },
      {
        type: 'paragraph',
        text: 'Submit the affidavit and published newspaper ad copies to passport offices, UIDAI, Income Tax Department (for PAN), etc., for updating your documents.'
      }
    ]
  }
];
